import { append, includes, without } from 'ramda';

export const toggle = <TItem>(item: TItem, items: readonly TItem[]) =>
	includes(item, items) ? without([item], items) : append(item, items);
